const storeName = 'ORDER';
export default {
    SET_LOADING: `${storeName}.SET_LOADING`,
    LOAD_ORDER: `${storeName}.LOAD_ORDER`,
    CLEAR_ORDER: `${storeName}.CLEAR_ORDER`,
    SET_ORDER_DATA: `${storeName}.SET_ORDER_DATA`,
    SET_DATA_TYPE: `${storeName}.SET_DATA_TYPE`,
    REPEAT_ORDER: `${storeName}.REPEAT_ORDER`,
    SET_EGIFT_CARD_ENTRY_NUMBER: `${storeName}.SET_EGIFT_CARD_ENTRY_NUMBER`,
    SET_EGIFT_CARD_RESEND_ATTEMPTS: `${storeName}.SET_EGIFT_CARD_RESEND_ATTEMPTS`,
    SET_CURRENT_ERROR_CODE: `${storeName}.SET_CURRENT_ERROR_CODE`,
    DOWNLOAD_INVOICE: `${storeName}.DOWNLOAD_INVOICE`,
    RESET_ERROR_CODE: `${storeName}.RESET_ERROR_CODE`,
    TRACK_ORDER: `${storeName}.TRACK_ORDER`,
    OPEN_CANCEL_DIALOG: `${storeName}.OPEN_CANCEL_DIALOG`,
    CANCEL_ORDER: `${storeName}.CANCEL_ORDER`,
};
